import { Navigate } from "react-router-dom";

export default function Signup() {
  return <Navigate to="/login" state={{ mode: "register" }} replace />;
}
